import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'url-search-params-polyfill'
import 'date-time-format-timezone'

import 'stylesheets/normalize.css'

import React from 'react'
import { createRoot } from 'react-dom/client'

import { datadogLogs } from '@datadog/browser-logs'

import App from 'components/App'
import { FLOW_TOKEN_DEPARTURE_GLOBAL } from 'constants/flowToken'

// ProTip: Set DATADOG_ENVIRONMENT to 'development:username' in your
// .env.local to make development easier
const env = process.env.DATADOG_ENVIRONMENT

datadogLogs.init({
  clientToken: 'pub1c09a91535f5ba2fa778c377d464f452',
  env,
  forwardErrorsToLogs: false,
  service: 'dashboard',
  sessionSampleRate: 100,
  site: 'datadoghq.com',
})

// A page that is leaving for the flow token page renders nothing, so that it
// sends no request of its own before it is replaced.
if ( !window[FLOW_TOKEN_DEPARTURE_GLOBAL] ) {
  createRoot(document.getElementById('app')).render(<App />)
}
